import { render, staticRenderFns } from "./ProfesorCrearCuenta.vue?vue&type=template&id=f3c8831a&"
import script from "./ProfesorCrearCuenta.vue?vue&type=script&lang=js&"
export * from "./ProfesorCrearCuenta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports